import { required } from 'vee-validate/dist/rules';

export const managerConfirmationValidator = {
    ...required,
    message(field: string) {
        return 'You need to confirm that you are the Manager of this organisation before proceeding';
    },
};
